import { Link, useLocation, ChevronDown } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 56168, offsets 240057:249556. Structure and names inferred from code, not screenshots.
import * as React from "react";
import { module33577 as r } from "../vendor/dependencies.js";
import * as DocumentTitlesModule from "../routing/documentTitles.js";
import * as LocaleContext from "../i18n/I18nProvider.jsx";
import * as AnalyticsContext from "../analytics/AnalyticsProvider.jsx";
import * as ClassNamesModule from "../utils/classNames.js";
import * as LocalizedPathsModule from "../routing/localizedPaths.js";
import * as DocumentEventsModule from "../routing/documentEvents.js";
function Component({
  className: e = "",
  disabled: disabled,
  children: children,
  href: href,
  to: to,
  ...r
}) {
  return disabled ? (
    <div className={(0, ClassNamesModule.cn)(e, "cursor-not-allowed")}>
      {children}
    </div>
  ) : (
    <Link className={(0, ClassNamesModule.cn)(e)} to={to ?? href ?? ""} {...r}>
      {children}
    </Link>
  );
}
function f(e) {
  return "string" == typeof e.href;
}
function M(e) {
  return (
    null != e &&
    "object" == typeof e &&
    (!("spacer" in e) || !e.spacer) &&
    "href" in e &&
    "string" == typeof e.href
  );
}
function y(e, t, i, n) {
  return (
    !!e &&
    e.some((e) => {
      if (!M(e)) return false;
      let o = x(t, e, n);
      return (
        i === (o.startsWith(n) ? o : `${n}${o}`) ||
        i === o ||
        y(e.items, o, i, n)
      );
    })
  );
}
function x(e, t, i) {
  let n =
    "agreementFullPath" in t && t.agreementFullPath
      ? String(t.agreementFullPath).replace(/^\/+/u, "")
      : "";
  return n ? `${i}/${n}` : `${e}${t.href}`;
}
function DocNavItem(e) {
  let t,
    i = useLocation(),
    { language: language } = (0, LocaleContext.useI18n)(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    k = (0, LocalizedPathsModule.$C)(i.pathname),
    T = (0, LocalizedPathsModule.z9)(i.pathname) ?? "/docs",
    C = (0, React.useRef)(null),
    [w, A] = (0, React.useState)(false),
    [D, j] = (0, React.useState)(
      () => !e.defaultCollapse || (f(e) && y(e.items, e.href, k, T)),
    ),
    v = (0, React.useCallback)(() => {
      let e = C.current;
      e && A(e.scrollWidth > e.clientWidth);
    }, []),
    I = f(e),
    P = I ? (0, DocumentTitlesModule.getLocalizedTitle)(e, language) : "";
  if (
    ((0, React.useEffect)(() => {
      v();
    }, [P, v]),
    (0, React.useEffect)(() => {
      I && y(e.items, e.href, k, T) && j(true);
    }, [k, e.href, e.items, I, T]),
    !I)
  )
    return null;
  let {
      href: href,
      items: items,
      noLink: noLink,
      level: level,
      isSheet: isSheet,
      onClose: onClose,
      titleZh: titleZh,
    } = e,
    V = !!(items && items.length > 0),
    F = 0 === level && V && !["最新", "往期新闻"].includes(titleZh),
    Y = href.startsWith(T) ? href : `${T}${href}`,
    R =
      href.includes("/api/") &&
      ["/chat/", "/audio/", "/model/"].some((e) => href.includes(e));
  if (
    (href.includes("/api/") &&
      (href.endsWith("/chat")
        ? (t =
            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjgzMzQgNS4yNDYzNUMxMi44MzM0IDMuMzE1MzcgMTEuMjcyMSAxLjc1IDkuMzMyOTkgMS43NUg0LjY2NzEyQzIuNzMzODkgMS43NSAxLjE2NjcxIDMuMzIxOTYgMS4xNjY3MSA1LjI0NjM1VjEyLjI1SDkuMzMyOTlDMTEuMjY2MiAxMi4yNSAxMi44MzM0IDEwLjY3OCAxMi44MzM0IDguNzUzNjdWNS4yNDYzNVpNMi4zMzMzNyAxMS4wODMzVjUuMjQ2MzVDMi4zMzMzNyAzLjk2Mzk4IDMuMzgwNTIgMi45MTY2NyA0LjY2NzEyIDIuOTE2NjdIOS4zMzI5OUMxMC42MjU3IDIuOTE2NjcgMTEuNjY2NyAzLjk1NzY3IDExLjY2NjcgNS4yNDYzNVY4Ljc1MzY3QzExLjY2NjcgMTAuMDM2IDEwLjYxOTYgMTEuMDgzMyA5LjMzMjk5IDExLjA4MzNIMi4zMzMzN1pNNS44MzMzNyA2LjQxNjY3SDQuNjY2NzFWNy41ODMzM0g1LjgzMzM3VjYuNDE2NjdaTTkuMzMzMzcgNi40MTY2N0g4LjE2NjcxVjcuNTgzMzNIOS4zMzMzN1Y2LjQxNjY3WiIgZmlsbD0iIzFBMUExQSIvPgo8L3N2Zz4K")
        : href.endsWith("/audio")
          ? (t =
              "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CjxyZWN0IHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgZmlsbD0idXJsKCNwYXR0ZXJuMF80MV83NzMpIi8+CjxkZWZzPgo8cGF0dGVybiBpZD0icGF0dGVybjBfNDFfNzczIiBwYXR0ZXJuQ29udGVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgd2lkdGg9IjEiIGhlaWdodD0iMSI+Cjx1c2UgeGxpbms6aHJlZj0iI2ltYWdlMF80MV83NzMiIHRyYW5zZm9ybT0ic2NhbGUoMC4wMjA4MzMzKSIvPgo8L3BhdHRlcm4+CjxpbWFnZSBpZD0iaW1hZ2UwXzQxXzc3MyIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB4bGluazpocmVmPSJkYXRhOmltYWdlL3BuZztiYXNlNjQsaVZCT1J3MEtHZ29BQUFBTlNVaEVVZ0FBQURBQUFBQXdDQVlBQUFCWEF2bUhBQUFBQ1hCSVdYTUFBQ0U0QUFBaE9BRkZsakZnQUFBQUFYTlNSMElBcnM0YzZRQUFBQVJuUVUxQkFBQ3hqd3Y4WVFVQUFBRVVTVVJCVkhnQjdkay9Eb0l3RkFid1IvMlRqbzZPZGZNYTNrQnY0bEc4Z2Q1QWI2REhjTE9qbzJPakFhVkVFMUFTcEZoZWl0OHZZYWdoVHo1Slg2VVFBVURRSXZKa3JLWXFQejdyb3lZUHZBVElMajZKVDRVUFJXL2lJNFNnd0NFQU53VGcxaWNIU3FtUklUbDZqU1daaTliNlVxUEVSNXQxcVdFNTNRR1RESmRabTN3ZTVqN1lVbDMzZUYyb1lXczZ3QnpnaGdEY3V0bEdmOVhpbW5odjFWYlpuOEh5TzVBayswS0xpd2R6YWxuMm5ibHJTSTk5MlhtWUE5d1FnQnNDY092bzg0QVFzL3pRTG1UVU10bTc3ZEtGN0ZCMVhta0FYM3M0ZFR4WC9zb2ZEbk9BR3dKdys4OXRGU211cTdURmJhZ0JHZDBXSmlwdXpaQURwd0RmdGpqZk5Tek1BVzRJd0MzNEFNRy81QU9Bd0QwQXJ5Qjc2aFg3NlNFQUFBQUFTVVZPUks1Q1lJST0iLz4KPC9kZWZzPgo8L3N2Zz4K")
          : href.endsWith("/model") &&
            (t =
              "data:image/svg+xml;base64,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")),
    V)
  )
    return (
      <div
        className={"flex w-full flex-col gap-[1px]"}
        data-doc-nav-href={Y}
        style={{
          marginBottom: 24 * (0 === level),
        }}
      >
        <button
          type={"button"}
          aria-expanded={D}
          className={(0, ClassNamesModule.cn)(
            "flex items-center gap-[4px] pr-[12px] h-[32px] w-full bg-transparent border-0 text-left rounded-[6px]",
            F
              ? "cursor-default"
              : "cursor-pointer hover:bg-[var(--color-surface-hover)]",
          )}
          style={{
            paddingLeft: level < 2 ? 8 : (level - 1) * 16 + 8,
          }}
          onClick={F ? undefined : () => j((e) => !e)}
        >
          {t && <img src={t} alt={""} className={"size-[14px] shrink-0"} />}
          <span
            className={
              "flex-1 min-w-0 truncate font-medium text-[13px] leading-[32px] text-black tracking-[-0.16px] whitespace-nowrap"
            }
          >
            {P}
          </span>
          {!F && (
            <ChevronDown
              size={14}
              className={(0, ClassNamesModule.cn)(
                "shrink-0 text-[#646a73] transition-transform duration-150",
                D ? "rotate-0" : "-rotate-90",
              )}
            />
          )}
        </button>
        {D && (
          <div className={"flex flex-col gap-px w-full"}>
            {items.map((e) => {
              if (!M(e)) return null;
              let t = {
                ...e,
                href: x(href, e, T),
                level: level + 1,
                isSheet: isSheet,
                onClose: onClose,
              };
              return (0, React.createElement)(DocNavItem, {
                ...t,
                key: e.key,
              });
            })}
          </div>
        )}
      </div>
    );
  let B = k === Y || k === href,
    Q = (
      <r.A title={w ? P : undefined}>
        <span
          ref={C}
          className={
            "flex-1 min-w-0 truncate text-[14px] leading-[20px] tracking-[-0.16px] text-[#282828]"
          }
        >
          {P}
        </span>
      </r.A>
    ),
    q = href.includes("/model/"),
    Z = R ? (
      <span
        className={(0, ClassNamesModule.cn)(
          "inline-flex w-[32px] shrink-0 items-center justify-center rounded-[6px] px-[4px] py-[2px] text-[8.8px] font-normal leading-[11px] whitespace-nowrap",
          q
            ? "bg-[rgba(59,179,70,0.2)] text-[#16a34a]"
            : "bg-[rgba(96,165,250,0.2)] text-[#1d4ed8]",
        )}
      >
        {q ? "GET" : "POST"}
      </span>
    ) : null;
  return (
    <div
      data-doc-nav-href={Y}
      className={(0, ClassNamesModule.cn)(
        "w-full rounded-[6px] transition-colors",
        B
          ? "bg-[var(--color-surface-hover)]"
          : F
            ? ""
            : "hover:bg-[var(--color-surface-hover)]",
      )}
    >
      {noLink ? (
        <div
          className={"flex h-[32px] items-center gap-[4px] pr-[8px] w-full"}
          style={{
            paddingLeft: level < 2 ? 8 : (level - 1) * 16 + 8,
          }}
        >
          {Z}
          {Q}
        </div>
      ) : (
        <Component
          href={href}
          to={href}
          onClick={() => {
            ((0, DocumentEventsModule.X)(),
              track("track", "docs_navi_click", {
                button: P,
                doc_path: Y,
              }),
              isSheet && onClose && onClose());
          }}
          className={
            "flex h-[32px] items-center gap-[8px] pr-[8px] w-full rounded-[6px]"
          }
          style={{
            paddingLeft: level < 2 ? 8 : (level - 1) * 16 + 8,
          }}
        >
          {Z}
          {Q}
        </Component>
      )}
    </div>
  );
}
export { DocNavItem };
